declare namespace $ {

	export class $bog_gamengine_draw extends $mol_view {
		width( ): number
		height( ): number
		dom_name( ): string
		field( ): ({ 
			'width': ReturnType< $bog_gamengine_draw['width'] >,
			'height': ReturnType< $bog_gamengine_draw['height'] >,
		})  & ReturnType< $mol_view['field'] >
		dpr( ): number
		scene( ): $bog_gamengine_scene
		cam( ): $bog_gamengine_cam
		light_dir( ): Float32Array
		clear( next?: Float32Array ): Float32Array
		fog( next?: Float32Array ): Float32Array
		fog_color( next?: Float32Array ): Float32Array
		ambient( ): number
		wireframe( next?: boolean ): boolean
		shadows( next?: boolean ): boolean
		shadow_size( next?: number ): number
		shadow_range( next?: number ): number
		post( next?: boolean ): boolean
		Tone( ): $bog_gamengine_shader_post_tone
		passes( ): readonly(any)[]
		stat( ): string
		peak( ): number
		report( ): ({ 
			'tick': number,
			'fill': number,
			'shadow': number,
			'main': number,
			'post': number,
			'batches': number,
			'instances': number,
			'draws': number,
			'triangles': number,
			'bytes': number,
		}) 
	}
	
}

//# sourceMappingURL=draw.view.tree.d.ts.map